function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-list",
  "data-name": "Icon feather-list",
  transform: "translate(-3.5 -8)",
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_24",
  "data-name": "Path 24",
  d: "M12,9H28.122",
  transform: "translate(-1.299)",
  fill: "none",
  stroke: "#6f7493",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_25",
  "data-name": "Path 25",
  d: "M12,18H28.122",
  transform: "translate(-1.299 -1.559)",
  fill: "none",
  stroke: "#6f7493",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_26",
  "data-name": "Path 26",
  d: "M12,27H28.122",
  transform: "translate(-1.299 -3.118)",
  fill: "none",
  stroke: "#6f7493",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_27",
  "data-name": "Path 27",
  d: "M4.5,9h0",
  fill: "none",
  stroke: "#6f7493",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_28",
  "data-name": "Path 28",
  d: "M4.5,18h0",
  transform: "translate(0 -1.559)",
  fill: "none",
  stroke: "#6f7493",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_29",
  "data-name": "Path 29",
  d: "M4.5,27h0",
  transform: "translate(0 -3.118)",
  fill: "none",
  stroke: "#6f7493",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

var SvgTableView = function SvgTableView(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.323,
    height: 16.882,
    viewBox: "0 0 24.323 16.882",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTableView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/table-view.3298144a.svg";
export { ForwardRef as ReactComponent };